export function scrollToViewFromTop(selector) {
  setTimeout(() => {
    const y = document.getElementById(selector);
    // const y = document.getElementById(selector).getBoundingClientRect().top;
    // window.scrollTo({
    //   top: y - 80,
    //   behavior: 'smooth'
    // })
    y.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }, 300)
}